// US SMS-by-email carrier gateways. The `value` is the gateway domain
// (no leading "@"); building an SMS address is `${phone}@${value}`.
export const SMS_CARRIERS = [
  { value: '', label: 'Select carrier...' },
  { value: 'txt.att.net', label: 'AT&T' },
  { value: 'vtext.com', label: 'Verizon' },
  { value: 'tmomail.net', label: 'T-Mobile' },
  { value: 'messaging.sprintpcs.com', label: 'Sprint' },
  { value: 'msg.fi.google.com', label: 'Google Fi' },
  { value: 'vmobl.com', label: 'Virgin Mobile' },
  { value: 'sms.myboostmobile.com', label: 'Boost Mobile' },
  { value: 'mymetropcs.com', label: 'Metro PCS' },
  { value: 'text.republicwireless.com', label: 'Republic Wireless' },
  { value: 'cspire1.com', label: 'C-Spire' },
  { value: 'sms.uscc.net', label: 'US Cellular' }
];

export function carrierLabel(value) {
  return SMS_CARRIERS.find(c => c.value === value)?.label || value;
}
